import React from "react";
import { getImageURL } from "../util/getImage";
const IMAGE_BASE_PATH = process.env.REACT_APP_DEV_IMAGE_BASE_PATH;
const placeholderImg = `${IMAGE_BASE_PATH}/ui/DummyImage/small.png`

// Generic ImageWidget Component
const ImageWidget = ({ value, options }) => {
  if (!value) return null;

  const { alt = "Image", style = {}, className = "" , width="50", height="50"} = options || {};
  return (
    <img
      src={getImageURL(value, width, height)}
      alt={alt}
      style={{ maxWidth: "50%", ...style }}
      width={"64px"}
      height={"64px"}
      objectFit={"contain"}
      className={className}
      fallbackSrc={placeholderImg}
    />
  );
};

export default ImageWidget;
